import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useSpring, animated } from 'react-spring';
import styled from '@emotion/styled';

import NewReplyBox from './NewReplyBox';

const NewReplyBoxWrapContainer = styled('div')`
  margin-top: 8px;
`;

const NewReplyBoxWrap = ({
  feedObject,
  commentObject,
  showReplies,
  setShowReplies,
}) => {
  const isReplyActivated = useSelector(
    (state) => state.feed.data.isReplyActivated[commentObject.id],
  );

  const [localReplyAnim, setLocalReplyAnim] = useState(false);

  useEffect(() => {
    if (isReplyActivated) {
      setLocalReplyAnim(true);
    } else {
      setLocalReplyAnim(false);
    }
  }, [isReplyActivated]);

  const messageBoxProps = useSpring({ height: localReplyAnim ? '35px' : '0px', opacity: localReplyAnim ? 1 : 0 });

  return isReplyActivated ? (
    <NewReplyBoxWrapContainer>
      <animated.div className='message-box-div' style={messageBoxProps}>
        <NewReplyBox
          feedObject={feedObject}
          commentObject={commentObject}
          showReplies={showReplies}
          setShowReplies={setShowReplies}
        />
      </animated.div>
    </NewReplyBoxWrapContainer>
  )
    : null;
};

NewReplyBoxWrap.propTypes = {
  feedObject: PropTypes.instanceOf(Object).isRequired,
  commentObject: PropTypes.instanceOf(Object).isRequired,
  showReplies: PropTypes.bool.isRequired,
  setShowReplies: PropTypes.func.isRequired,
};

export default NewReplyBoxWrap;
